import ApiCompanyUser from './company-user';
import ApiTodoListTemplate from './todo-list-template';
import ApiCompanyApiV2 from './api-v2';

import Request from 'gd-request';
import ApiPriorities from "./priorities";

class ApiCompany {

    constructor() {
        this.Invitations        = new ApiCompanyInvitations();
        this.Reports            = new ApiCompanyReports();
        this.User               = new ApiCompanyUser();
        this.TodoListTemplate   = new ApiTodoListTemplate();
        this.ApiV2              = new ApiCompanyApiV2();
        this.Priorities         = new ApiPriorities();
    }

    // universal update...
    update(companyId, params) {
        return new Request(this, 'PUT', 'company/' + companyId + '/update', params);
    }

    resetCache() {
        return new Request(this, 'POST', 'company/reset-cache', {});
    }

    addDepartment(companyId, name) {
        return new Request(this,'post','company/'+companyId+'/departments',{
            name: name
        });
    }

    addProjectTypeStatus(companyId, projectTypeId, params) {
        return new Request(this, 'POST', 'company/'+companyId+'/project-type/'+projectTypeId+'/statuses', params);
    }

    deleteProjectTypeStatus(companyId, projectTypeId, statusId) {
        return new Request(this, 'DELETE', 'company/'+companyId+'/project-type/'+projectTypeId+'/status/'+statusId);
    }

    //common for projectType and taskType
    editStatus(companyId, statusId, params) {
        return new Request(this, 'PUT', 'company/'+companyId+'/status/'+statusId, params);
    }

    saveProjectTypeStatusesOrderPositions(companyId, projectTypeId, params) {
        return new Request(this, 'PUT', 'company/'+companyId+'/project-type/'+projectTypeId+'/statuses', params);
    }

    addTaskTypeStatus(companyId, taskTypeId, params) {
        return new Request(this, 'POST', 'company/'+companyId+'/task-type/'+taskTypeId+'/task-statuses', params);
    }

    deleteTaskTypeStatus(companyId, taskTypeId, statusId) {
        return new Request(this, 'DELETE', 'company/'+companyId+'/task-type/'+taskTypeId+'/task-status/'+statusId);
    }

    saveTaskTypeStatusesOrderPositions(companyId, taskTypeId, params) {
        return new Request(this, 'PUT', 'company/'+companyId+'/task-type/'+taskTypeId+'/task-statuses', params);
    }

    addStatus(companyId, name, color, systemStatus, description) {
        return new Request(this, 'POST', 'company/'+companyId+'/statuses', {
            name: name,
            color: color,
            systemStatus: systemStatus,
            description: description
        });
    }

    /*editStatus(companyId, statusId, name, color, description) {
        return new Request(this, 'PUT', 'company/'+companyId+'/status/'+statusId, {
            name: name,
            color: color,
            description: description
        });
    }*/

    deleteStatus(companyId, statusId) {
        return new Request(this, 'DELETE', 'company/'+companyId+'/status/'+statusId);
    }

    saveSettings(companyId, settings) {
        return new Request(this, 'PUT', 'company/' + companyId + '/settings', { settings });
    }

    getSubscriptionDetails(companyId) {
        return new Request(this, 'GET', 'company/' + companyId + '/subscription');
    }

    getFinance(companyId) {
        return new Request(this, 'GET', 'company/' + companyId + '/finance');
    }

    // not in use...
    // updateFinance(companyId, finance, currency, internal, external) {
    //
    //     const params = {
    //         finance: finance,
    //         // currency: currency,
    //         internal: internal,
    //         external: external
    //     }
    //
    //     return this.update(companyId, params)
    //
    //     return new Request(this, 'PUT', 'company/' + companyId + '/finance', {
    //         finance: finance,
    //         currency: currency,
    //         internal: internal,
    //         external: external
    //     });
    // }

    setFullAccess(companyId, value) {
        return new Request(this, 'PUT', 'company/{0}/settings/default-access'.f(companyId), {
            defaultAccess: value
        });
    }

    // BILLING AND SUBSCTIPTION
    getUpgradeDiscount() {
        return new Request(this,'GET','company/'+gd.companyId+'/upgrade');
    }

    //
    // apiV2GetToken(companyId) {
    //     return new Request(this,'GET','company/'+companyId+'/admin/api_2_0');
    // }

    // apiV2IssueToken(companyId) {
    //     return new Request(this,'POST','company/'+companyId+'/admin/api_2_0');
    // }

    // apiV2DeleteToken(companyId) {
    //     return new Request(this,'Delete','company/'+companyId+'/admin/api_2_0');
    // }


    // EXPENSE CATEGORIES

    // always done via session reset now
    /*getExpenseCategories() {
        return new Request(this, 'GET', 'company/expense-categories');
    }*/

    // expenseCategoriesUpdateSortPosition(arrIds) {
    //     return new Request(this, 'PUT', 'company/expense-categories',{
    //         arrIds
    //     });
    // }

    // expenseCategoryCreate(name, sortPosition) {
    //     return new Request(this, 'POST', 'company/expense-categories',{
    //         name: name,
    //         sortPosition: sortPosition
    //     });
    // }

    // expenseCategoryUpdate(id, name, isDeleted) {
    //     return new Request(this, 'PUT', 'company/expense-categories/'+id,{
    //         name,
    //         isDeleted
    //     });
    // }

}


class ApiCompanyInvitations {

    constructor() {}

    resendInvitation(invitationId) {
        return new Request(this,'PUT','company/invitation/'+invitationId);
    }

    newInvitations(invitationsData) {

        return new Request(this,'POST','company/invitation',{
            invitations: invitationsData
        });
    }

}

class ApiCompanyReports {

    constructor() {}

    reportSettings(companyId, arrNotificationUsers, duration, nextReportDate, isEnabled) {
        return new Request(this,'PUT','report/settings/company/'+companyId,{
            users: arrNotificationUsers,
            duration: duration,
            nextReportDate: nextReportDate,
            isEnabled: isEnabled
        });
    }
}


module.exports = ApiCompany;
